import {
  createTheme,
  Fade,
  IconButton,
  MuiThemeProvider,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import axios from "axios";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { useEffect, useState } from "react";
import icoExcelDorado from "../../assets/images/icoExcelDorado.svg";
import { appSettings } from "../endpoints";

export default function ReporteLocalSentencias(
  props: reporteLocalSentenciasProps
) {
  const [loader, setLoader] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [dataOriginal, setDataOriginal] = useState<any[]>([]);
  const [state, setState] = useState<{ open: boolean }>({ open: false });
  const handleCloseSnack = () => setState({ open: false });
  const [heightFiltro, setHeightFiltro] = useState(0);
  const [download, setDownload] = useState("");
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [API_Service, setApiService] = useState("");
  const [Sentencia_HTML, setSentenciaHTML] = useState("");
  const removeAccents = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  } 

  const columns = [
    "Año",
    "Consecutivo",
    "Magistrado",
    "Medio",
    "Observación",
    "Sala",
    "Sentencia",
  ];

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableHeadCell: {
          root: {
            backgroundColor: "#24135f !important",
            borderBottom: "1px solid #000",
            borderRight: "1px solid #B0B0AA",
            borderLeft: "1px solid #B0B0AA",
            borderTop: "1px solid #B0B0AA",
          },
          data: {
            color: "#FFFF !important",
            fontWeight: "bold",
          },
        },
        MUIDataTableBodyRow: {
          root: {
            backgroundColor: "#e3e1eb",
          },
        },
        MUIDataTablePagination: {
          root: {
            backgroundColor: "#c2b5f1",
            color: "#000000",
          },
        },
        MuiIconButton: {
          root: {
            color: "#b1a252",
          },
        },
      },
    });

  const options: MUIDataTableOptions = {
    serverSide: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    selectableRows: "none",
    rowsPerPage: 20,
    rowsPerPageOptions: [20],
    // confirmFilters: true,
    tableBodyHeight: `${props.alto - (heightFiltro * 2.3 + 10)}px`,
    print: false,
    search: false,
    filter: false,
    textLabels: {
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Total de registros por página",
        displayRows: "de",
      },
      filter: {
        reset: "Limpiar",
        title: "Filtros",
      },
      toolbar: {
        downloadCsv: "Descarga CSV",
        filterTable: "Filtros de tabla",
        search: "Búsqueda",
        viewColumns: "Mostrar/Ocultar",
      },
      body: {
        noMatch: "No se encontraron resultados",
        toolTip: "Ordenar",
      },
      viewColumns: {
        title: "Ver columnas",
      },
    },
    count: totalPages,
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          getSentencias(tableState.page + 1);
          break;
        default:
          console.log("action not handled.");
      }
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      setLoader(true);
      let columnas: string[] = columns.reduce((acc: string[], cvv: any) => {
        acc.push(cvv.name);
        return acc;
      }, []);
      let datosCSV: any[] = [];
      dataOriginal.forEach((obj: any, idx: number) => {
        let body: string[] = [];
        for (let prop in obj) {
          if (columnas.indexOf(prop) !== -1) body.push(obj[prop]);
        }
        datosCSV.push({ index: idx, data: body });
      });
      setDownload(`${buildHead(columns)}${buildBody(datosCSV)}`.trim());
      setLoader(false);

      return false;
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      if (searchQuery.length <= 3) return true;

      setTextoBusqueda(searchQuery);

      currentRow.forEach((col) => {
        if (col.toString().indexOf(searchQuery) >= 0) {
          isFound = true;
        }
      });
      return isFound;
    },
    customToolbar: () => {
      return (
        <>
          <Tooltip title={"Descarga excel"}>
            <IconButton onClick={btnExcel(dataSource, "Sentencias")}>
              <img
                style={{ width: "30px", height: "30px" }}
                src={icoExcelDorado}
                alt=""
              />
            </IconButton>
          </Tooltip>
        </>
      );
    },
  };

  //#region Effects

  useEffect(() => {
    appSettings.then((res) => {
      setApiService(res.EXPEDIENTES_CONSULTA);
      setSentenciaHTML(res.SENTENCIA_HTML);
    });
  }, []);

  useEffect(() => {
    if (API_Service === "") return;

    getSentencias(1);
  }, [API_Service]);

  useEffect(() => {
    if (download.length > 0) {
      let blob = new Blob(["\ufeff", download], {
        type: "text/csv;charset=windows-1252;",
      });
      let a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = "Sentencias.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setDownload("");
    }
  }, [download]);
  //#endregion

  //#region Services
  async function getSentencias(currentPage: number) {
    let sentenciaData: any[] = [];
    let dataPage: any[] = [];

    let dOriginal: any[] = [];
    let linkSentencia: string = "";
    setDataSource([]);
    setDataOriginal([]);
    try {
      let texto = ""
      for (const [key, value] of Object.entries(props.camposReporte)) {
        if (props.camposReporte[key]["nombreColumna"] === "BuscarSentencias") {
          texto = props.camposReporte[key]["valor"][0];
          break;
        }
      }
      texto = removeAccents(texto);


      let years = buildYears(props.camposReporte["Año"].valor);
      texto = removeAccents(texto);
      let filters: any = {
        texto: texto,
        anio: years.toString(),
      };

      if (props.camposReporte["Sala"].valor.length > 0 && props.camposReporte["Sala"].valor[0] !== '')
        filters["sala"] = props.camposReporte["Sala"].valor.toString().trim();

      if (props.camposReporte["Medio"].valor.length > 0 && props.camposReporte["Medio"].valor[0] !== '')
        filters["medio"] = props.camposReporte["Medio"].valor.toString().trim();

      if (props.camposReporte["Consecutivo"].valor.length > 0 && props.camposReporte["Consecutivo"].valor[0] !== '')
        filters["consecutivo"] = parseInt(props.camposReporte["Consecutivo"].valor[0]);

      if (currentPage > 1)
        filters["pagina"] = currentPage;

      let res = await axios.post(API_Service, filters);
      res.data.resultados.forEach((e: sentencia) => {
        linkSentencia = `https://www.te.gob.mx/sentenciasHTML/convertir/expediente/${e.sala[0]}-${e.medio[0]}-${e.consecutivo[0]}-${e.anho[0]}`;
        if (e.obs[0].length > 0) linkSentencia += `-${e.obs[0]}`;

        sentenciaData.push(e.anho[0].toString());
        sentenciaData.push(e.consecutivo[0].toString());
        sentenciaData.push(e.magistrado[0]);
        sentenciaData.push(e.medio[0]);
        sentenciaData.push(e.obs[0]);
        sentenciaData.push(e.sala[0]);
        sentenciaData.push(
          <a href={linkSentencia} target="_blank">
            Ir a sentencia
          </a>
        );

        dOriginal.push({
          Año: e.anho[0].toString(),
          Consecutivo: e.consecutivo[0].toString(),
          Magistrado: e.magistrado[0],
          Medio: e.medio[0],
          Observación: e.obs[0],
          Sala: e.sala[0],
          Sentencia: linkSentencia,
        });
        dataPage.push(sentenciaData);
        sentenciaData = [];
      });
      setDataSource(dataPage);
      setDataOriginal(dOriginal);
      setTotalPages(res.data.total);
    } catch (error) {
      console.log(error);
    }
  }

  const buildYears = (years: string[]) => {
    let dif = parseInt(years[1]) - parseInt(years[0]);
    let yearsComplete: string[] = [];
    let firstYear: number;

    if (dif === 0) return [years[1]];
    else if (dif === 1) return years;
    else {
      for (let i = 0; i <= dif; i++) {
        firstYear = parseInt(years[0]) + i;

        yearsComplete.push(`${firstYear}`);
      }
      return yearsComplete;
    }
  };
  //#endregion

  //#region Events
  const btnExcel =
    (datos: any, nombre: string) => (event: React.MouseEvent) => {
      props.generaExcel(dataOriginal, nombre);
    };

  //#endregion
  return (
    <>
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div>
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Expedientes"}
              data={dataSource}
              columns={columns}
              options={options}
              //components={{ TableFilterList: CustomFilterList }}
            />
          </MuiThemeProvider>
          <Snackbar
            open={state.open}
            onClose={handleCloseSnack}
            TransitionComponent={Fade}
            message="Error al recuperar datos del servidor."
            key={"fade"}
          />
        </div>
      )}
    </>
  );
}

interface reporteLocalSentenciasProps {
  camposReporte: any;
  alto: number;
  generaExcel(csvData: any, fileName: string): void;
}

interface sentencia {
  anho: number[];
  consecutivo: number[];
  magistrado: string[];
  medio: string[];
  obs: string[];
  sala: string[];
}

ReporteLocalSentencias.defaultProps = {
  recuperaDatos: true,
};
